import { PayloadAction } from "@reduxjs/toolkit";

import { NavigationState } from "../../types";

export const setClientRoadEventsData = (
  state: NavigationState,
  action: PayloadAction<NavigationState["clientEvents"]["road"]["data"]>
) => {
  state.clientEvents.road.data = action.payload;
};

export const setClientRoadEventLoadingStatus = (
  state: NavigationState,
  action: PayloadAction<
    NavigationState["clientEvents"]["road"]["loadingStatus"]
  >
) => {
  state.clientEvents.road.loadingStatus = action.payload;
};
